import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText, LabelText, TitleText } from '@calendly/ui/components/typography'

import {
  EXTERNAL,
  INTERNAL,
  LockedExternalSection,
  LockedInternalSection,
} from 'features/event_type_editor'

import { ConfirmationPageTypeField } from './confirmation_page_type_field'
import { ExternalSection } from './external_section'
import { InternalSection } from './internal_section'
import {
  headerCss,
  sectionCss,
  subsectionCss,
  tabCss,
} from './styles'

const ConfirmationTabLocked = () => {
  const { values: { confirmationPageType } } = useFormContext()

  return (
    <div className={tabCss} data-testid="confirmation-tab-locked">
      <header className={headerCss}>
        <TitleText level={2}>
          {I18n.t('publisher.event_type_editor_crud.confirmation.title')}
        </TitleText>
        <BodyText color="muted" size="large">
          {I18n.t('publisher.event_type_editor_crud.confirmation.subtitle')}
        </BodyText>
      </header>
      <div className={sectionCss}>
        <LabelText>
          {I18n.t('publisher.event_type_editor_crud.confirmation.after_booking_label')}
        </LabelText>
        {confirmationPageType === INTERNAL && <LockedInternalSection />}
        {confirmationPageType === EXTERNAL && <LockedExternalSection />}
      </div>
    </div>
  )
}

const ConfirmationTabEditable = () => {
  const { values: { confirmationPageType } } = useFormContext()

  return (
    <div className={tabCss} data-testid="confirmation-tab">
      <header className={headerCss}>
        <TitleText level={2}>
          {I18n.t('publisher.event_type_editor_crud.confirmation.title')}
        </TitleText>
        <BodyText color="muted" size="large">
          {I18n.t('publisher.event_type_editor_crud.confirmation.subtitle')}
        </BodyText>
      </header>
      <div className={sectionCss}>
        <div className={subsectionCss}>
          <LabelText>
            {I18n.t('publisher.event_type_editor_crud.confirmation.after_booking_label')}
          </LabelText>
          <ConfirmationPageTypeField />
        </div>
        {confirmationPageType === EXTERNAL && <ExternalSection />}
        <InternalSection />
      </div>
    </div>
  )
}

export const ConfirmationTab = ({ isLocked = false }) => (
  isLocked ? <ConfirmationTabLocked /> : <ConfirmationTabEditable />
)
